<template>
  <svg
    :class="className"
    fill="none"
    :height="height"
    viewBox="0 0 40 40"
    :width="width"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect height="24" rx="2" :stroke="fill" stroke-width="2" width="26" x="7" y="7"/>
    <rect :fill="fill" height="0.999959" rx="0.49998" :stroke="fill" stroke-width="0.999959" width="4.0007" x="5.49998" y="38.5"/>
    <rect :fill="fill" height="0.999959" :stroke="fill" stroke-width="0.999959" width="4.0007" x="5.49998" y="37.5"/>
    <rect :fill="fill" height="1.00021" rx="0.500107" :stroke="fill" stroke-width="1.00021" width="3.99979" x="30.5001" y="38.5001"/>
    <rect :fill="fill" height="1.00021" :stroke="fill" stroke-width="1.00021" width="3.99979" x="30.5001" y="37.5001"/>
    <rect height="34" rx="1.5" :stroke="fill" stroke-width="3" width="37.0001" x="1.5" y="1.5"/>
    <rect :fill="fill" height="5" rx="1" width="2" x="28" y="16"/>
    <circle cx="20" cy="19" :fill="fill" r="2"/>
    <path clip-rule="evenodd" d="M21.6053 14.7363C22.1431 14.1986 21.9772 13.2929 21.2298 13.1529C19.3491 12.8008 17.3326 13.3523 15.8775 14.8074C13.5343 17.1505 13.5343 20.9495 15.8775 23.2926C18.2206 25.6358 22.0196 25.6358 24.3627 23.2926C25.8178 21.8375 26.3693 19.821 26.0172 17.9403C25.8772 17.1929 24.9715 17.027 24.4338 17.5648C24.1556 17.8429 24.0588 18.2474 24.099 18.6387C24.2178 19.7947 23.8343 20.9926 22.9485 21.8784C21.3864 23.4405 18.8538 23.4405 17.2917 21.8784C15.7296 20.3163 15.7296 17.7837 17.2917 16.2216C18.1775 15.3358 19.3754 14.9523 20.5314 15.0711C20.9227 15.1113 21.3272 15.0145 21.6053 14.7363Z" :fill="fill" fill-rule="evenodd"/>
  </svg>

</template>

<script>
export default {
  name: 'Curated',
  props: {
    width: {
      type: String,
      required: false,
      default: '100%'
    },
    height: {
      type: String,
      required: false,
      default: '100%'
    },
    className: {
      type: String,
      required: false,
      default: ''
    },
    fill: {
      type: String,
      required: false,
      default: '#000'
    },
  },
};

</script>
